module.exports = __webpack_public_path__ + "img/three-line.bbcd067e.svg";